"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Accessorial = _interopRequireDefault(require("./Accessorial"));

var _CreateQuote = _interopRequireDefault(require("./CreateQuote"));

var _CreateSpotNegotiationQuoteAllOf = _interopRequireDefault(require("./CreateSpotNegotiationQuoteAllOf"));

var _FedexDirectQuote = _interopRequireDefault(require("./FedexDirectQuote"));

var _QuoteChargeLineItem = _interopRequireDefault(require("./QuoteChargeLineItem"));

var _SlimCompany = _interopRequireDefault(require("./SlimCompany"));

var _SpotNegotiationQuoteInfo = _interopRequireDefault(require("./SpotNegotiationQuoteInfo"));

var _UPSDirectQuote = _interopRequireDefault(require("./UPSDirectQuote"));

var _USPSDirectQuote = _interopRequireDefault(require("./USPSDirectQuote"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The CreateSpotNegotiationQuote model module.
 * @module model/CreateSpotNegotiationQuote
 * @version 2.7.64
 */
var CreateSpotNegotiationQuote = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>CreateSpotNegotiationQuote</code>.
   * Request body used to create a quote
   * @alias module:model/CreateSpotNegotiationQuote
   * @implements module:model/CreateQuote
   * @implements module:model/CreateSpotNegotiationQuoteAllOf
   */
  function CreateSpotNegotiationQuote() {
    _classCallCheck(this, CreateSpotNegotiationQuote);

    _CreateQuote["default"].initialize(this);

    _CreateSpotNegotiationQuoteAllOf["default"].initialize(this);

    CreateSpotNegotiationQuote.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(CreateSpotNegotiationQuote, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>CreateSpotNegotiationQuote</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CreateSpotNegotiationQuote} obj Optional instance to populate.
     * @return {module:model/CreateSpotNegotiationQuote} The populated <code>CreateSpotNegotiationQuote</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new CreateSpotNegotiationQuote();

        _CreateQuote["default"].constructFromObject(data, obj);

        _CreateSpotNegotiationQuoteAllOf["default"].constructFromObject(data, obj);

        if (data.hasOwnProperty('accepted_at')) {
          obj['accepted_at'] = _ApiClient["default"].convertToType(data['accepted_at'], 'Date');
        }

        if (data.hasOwnProperty('approved_by_rfq_at')) {
          obj['approved_by_rfq_at'] = _ApiClient["default"].convertToType(data['approved_by_rfq_at'], 'Date');
        }

        if (data.hasOwnProperty('can_dispatch')) {
          obj['can_dispatch'] = _ApiClient["default"].convertToType(data['can_dispatch'], 'Boolean');
        }

        if (data.hasOwnProperty('carrier')) {
          obj['carrier'] = _ApiClient["default"].convertToType(data['carrier'], 'String');
        }

        if (data.hasOwnProperty('charge_line_items')) {
          obj['charge_line_items'] = _ApiClient["default"].convertToType(data['charge_line_items'], [_QuoteChargeLineItem["default"]]);
        }

        if (data.hasOwnProperty('created_at')) {
          obj['created_at'] = _ApiClient["default"].convertToType(data['created_at'], 'Date');
        }

        if (data.hasOwnProperty('created_by_company')) {
          obj['created_by_company'] = _SlimCompany["default"].constructFromObject(data['created_by_company']);
        }

        if (data.hasOwnProperty('created_by_user')) {
          obj['created_by_user'] = _ApiClient["default"].convertToType(data['created_by_user'], 'String');
        }

        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }

        if (data.hasOwnProperty('customer_markup')) {
          obj['customer_markup'] = _ApiClient["default"].convertToType(data['customer_markup'], 'Number');
        }

        if (data.hasOwnProperty('delivery_date')) {
          obj['delivery_date'] = _ApiClient["default"].convertToType(data['delivery_date'], 'String');
        }

        if (data.hasOwnProperty('display_earliest_pickup')) {
          obj['display_earliest_pickup'] = _ApiClient["default"].convertToType(data['display_earliest_pickup'], 'String');
        }

        if (data.hasOwnProperty('earliest_pickup_date')) {
          obj['earliest_pickup_date'] = _ApiClient["default"].convertToType(data['earliest_pickup_date'], 'String');
        }

        if (data.hasOwnProperty('earliest_pickup_time')) {
          obj['earliest_pickup_time'] = _ApiClient["default"].convertToType(data['earliest_pickup_time'], 'String');
        }

        if (data.hasOwnProperty('equipment_type')) {
          obj['equipment_type'] = _ApiClient["default"].convertToType(data['equipment_type'], 'Number');
        }

        if (data.hasOwnProperty('error_message')) {
          obj['error_message'] = _ApiClient["default"].convertToType(data['error_message'], 'String');
        }

        if (data.hasOwnProperty('expires_at')) {
          obj['expires_at'] = _ApiClient["default"].convertToType(data['expires_at'], 'Date');
        }

        if (data.hasOwnProperty('fedex_direct_quote')) {
          obj['fedex_direct_quote'] = _FedexDirectQuote["default"].constructFromObject(data['fedex_direct_quote']);
        }

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'String');
        }

        if (data.hasOwnProperty('info_message')) {
          obj['info_message'] = _ApiClient["default"].convertToType(data['info_message'], 'String');
        }

        if (data.hasOwnProperty('is_csp_rate')) {
          obj['is_csp_rate'] = _ApiClient["default"].convertToType(data['is_csp_rate'], 'Boolean');
        }

        if (data.hasOwnProperty('is_failure')) {
          obj['is_failure'] = _ApiClient["default"].convertToType(data['is_failure'], 'Boolean');
        }

        if (data.hasOwnProperty('lane_type')) {
          obj['lane_type'] = _ApiClient["default"].convertToType(data['lane_type'], 'String');
        }

        if (data.hasOwnProperty('mode')) {
          obj['mode'] = _ApiClient["default"].convertToType(data['mode'], 'Number');
        }

        if (data.hasOwnProperty('provider_logo_url')) {
          obj['provider_logo_url'] = _ApiClient["default"].convertToType(data['provider_logo_url'], 'String');
        }

        if (data.hasOwnProperty('quoted_non_dispatchable_accessorials')) {
          obj['quoted_non_dispatchable_accessorials'] = _ApiClient["default"].convertToType(data['quoted_non_dispatchable_accessorials'], [_Accessorial["default"]]);
        }

        if (data.hasOwnProperty('reference_number')) {
          obj['reference_number'] = _ApiClient["default"].convertToType(data['reference_number'], 'String');
        }

        if (data.hasOwnProperty('revoked_at')) {
          obj['revoked_at'] = _ApiClient["default"].convertToType(data['revoked_at'], 'Date');
        }

        if (data.hasOwnProperty('rfq')) {
          obj['rfq'] = _ApiClient["default"].convertToType(data['rfq'], 'String');
        }

        if (data.hasOwnProperty('service_level')) {
          obj['service_level'] = _ApiClient["default"].convertToType(data['service_level'], 'Number');
        }

        if (data.hasOwnProperty('source_type')) {
          obj['source_type'] = _ApiClient["default"].convertToType(data['source_type'], 'String');
        }

        if (data.hasOwnProperty('spot_negotiation_quote')) {
          obj['spot_negotiation_quote'] = _SpotNegotiationQuoteInfo["default"].constructFromObject(data['spot_negotiation_quote']);
        }

        if (data.hasOwnProperty('total')) {
          obj['total'] = _ApiClient["default"].convertToType(data['total'], 'Number');
        }

        if (data.hasOwnProperty('transit_days')) {
          obj['transit_days'] = _ApiClient["default"].convertToType(data['transit_days'], 'Number');
        }

        if (data.hasOwnProperty('updated_at')) {
          obj['updated_at'] = _ApiClient["default"].convertToType(data['updated_at'], 'Date');
        }

        if (data.hasOwnProperty('ups_direct_quote')) {
          obj['ups_direct_quote'] = _UPSDirectQuote["default"].constructFromObject(data['ups_direct_quote']);
        }

        if (data.hasOwnProperty('usps_direct_quote')) {
          obj['usps_direct_quote'] = _USPSDirectQuote["default"].constructFromObject(data['usps_direct_quote']);
        }

        if (data.hasOwnProperty('message')) {
          obj['message'] = _ApiClient["default"].convertToType(data['message'], 'String');
        }
      }

      return obj;
    }
  }]);

  return CreateSpotNegotiationQuote;
}();
/**
 * @member {Date} accepted_at
 */


CreateSpotNegotiationQuote.prototype['accepted_at'] = undefined;
/**
 * Not implemented
 * @member {Date} approved_by_rfq_at
 */

CreateSpotNegotiationQuote.prototype['approved_by_rfq_at'] = undefined;
/**
 * @member {Boolean} can_dispatch
 */

CreateSpotNegotiationQuote.prototype['can_dispatch'] = undefined;
/**
 * Id of the carrier for this quote. A carrier should always be provided when the requester's company would in fact be the carrier for the shipment. 
 * @member {String} carrier
 */

CreateSpotNegotiationQuote.prototype['carrier'] = undefined;
/**
 * @member {Array.<module:model/QuoteChargeLineItem>} charge_line_items
 */

CreateSpotNegotiationQuote.prototype['charge_line_items'] = undefined;
/**
 * @member {Date} created_at
 */

CreateSpotNegotiationQuote.prototype['created_at'] = undefined;
/**
 * @member {module:model/SlimCompany} created_by_company
 */

CreateSpotNegotiationQuote.prototype['created_by_company'] = undefined;
/**
 * @member {String} created_by_user
 */

CreateSpotNegotiationQuote.prototype['created_by_user'] = undefined;
/**
 * Read-only currency code describing the currency of line items on the quote
 * @member {module:model/CreateSpotNegotiationQuote.CurrencyEnum} currency
 * @default 'USD'
 */

CreateSpotNegotiationQuote.prototype['currency'] = 'USD';
/**
 * Markup charge to the end customer, obfuscated so only authorized users can read/write its true value 
 * @member {Number} customer_markup
 */

CreateSpotNegotiationQuote.prototype['customer_markup'] = undefined;
/**
 * Planned delivery date of the shipment, in string of the form YYYY-MM-DD
 * @member {String} delivery_date
 */

CreateSpotNegotiationQuote.prototype['delivery_date'] = undefined;
/**
 * Human-readable date/time of earliest pickup, if one exists
 * @member {String} display_earliest_pickup
 */

CreateSpotNegotiationQuote.prototype['display_earliest_pickup'] = undefined;
/**
 * Earliest date the shipment could be run, in string of the form YYYY-MM-DD
 * @member {String} earliest_pickup_date
 */

CreateSpotNegotiationQuote.prototype['earliest_pickup_date'] = undefined;
/**
 * Earliest time the shipment could be run
 * @member {String} earliest_pickup_time
 */

CreateSpotNegotiationQuote.prototype['earliest_pickup_time'] = undefined;
/**
 * Id of the EquipmentType for this quote
 * @member {Number} equipment_type
 */

CreateSpotNegotiationQuote.prototype['equipment_type'] = undefined;
/**
 * Error that happened during quoting
 * @member {String} error_message
 */

CreateSpotNegotiationQuote.prototype['error_message'] = undefined;
/**
 * @member {Date} expires_at
 */

CreateSpotNegotiationQuote.prototype['expires_at'] = undefined;
/**
 * @member {module:model/FedexDirectQuote} fedex_direct_quote
 */

CreateSpotNegotiationQuote.prototype['fedex_direct_quote'] = undefined;
/**
 * @member {String} id
 */

CreateSpotNegotiationQuote.prototype['id'] = undefined;
/**
 * Description of caveats about the quote
 * @member {String} info_message
 */

CreateSpotNegotiationQuote.prototype['info_message'] = undefined;
/**
 * True iff Quote originated from a rate that a Brokerage negotiated on behalf of one of their FreightAuthorities 
 * @member {Boolean} is_csp_rate
 */

CreateSpotNegotiationQuote.prototype['is_csp_rate'] = undefined;
/**
 * if true, this Quote does not represent an actual price but instead a failure to provide a Quote to an RFQ 
 * @member {Boolean} is_failure
 */

CreateSpotNegotiationQuote.prototype['is_failure'] = undefined;
/**
 * @member {module:model/CreateSpotNegotiationQuote.LaneTypeEnum} lane_type
 * @default 'UNSPECIFIED'
 */

CreateSpotNegotiationQuote.prototype['lane_type'] = 'UNSPECIFIED';
/**
 * Id of the ShipmentMode for this quote
 * @member {Number} mode
 */

CreateSpotNegotiationQuote.prototype['mode'] = undefined;
/**
 * URL for the logo of the quote provider
 * @member {String} provider_logo_url
 */

CreateSpotNegotiationQuote.prototype['provider_logo_url'] = undefined;
/**
 * @member {Array.<module:model/Accessorial>} quoted_non_dispatchable_accessorials
 */

CreateSpotNegotiationQuote.prototype['quoted_non_dispatchable_accessorials'] = undefined;
/**
 * @member {String} reference_number
 */

CreateSpotNegotiationQuote.prototype['reference_number'] = undefined;
/**
 * Not implemented
 * @member {Date} revoked_at
 */

CreateSpotNegotiationQuote.prototype['revoked_at'] = undefined;
/**
 * Id of the RFQ to which this quote is related
 * @member {String} rfq
 */

CreateSpotNegotiationQuote.prototype['rfq'] = undefined;
/**
 * Id of the ServiceLevel for this quote
 * @member {Number} service_level
 */

CreateSpotNegotiationQuote.prototype['service_level'] = undefined;
/**
 * @member {module:model/CreateSpotNegotiationQuote.SourceTypeEnum} source_type
 */

CreateSpotNegotiationQuote.prototype['source_type'] = undefined;
/**
 * @member {module:model/SpotNegotiationQuoteInfo} spot_negotiation_quote
 */

CreateSpotNegotiationQuote.prototype['spot_negotiation_quote'] = undefined;
/**
 * Sum of all the charge line items of this quote
 * @member {Number} total
 */

CreateSpotNegotiationQuote.prototype['total'] = undefined;
/**
 * @member {Number} transit_days
 */

CreateSpotNegotiationQuote.prototype['transit_days'] = undefined;
/**
 * @member {Date} updated_at
 */

CreateSpotNegotiationQuote.prototype['updated_at'] = undefined;
/**
 * @member {module:model/UPSDirectQuote} ups_direct_quote
 */

CreateSpotNegotiationQuote.prototype['ups_direct_quote'] = undefined;
/**
 * @member {module:model/USPSDirectQuote} usps_direct_quote
 */

CreateSpotNegotiationQuote.prototype['usps_direct_quote'] = undefined;
/**
 * Message to include in quote created email
 * @member {String} message
 */

CreateSpotNegotiationQuote.prototype['message'] = undefined; // Implement CreateQuote interface:

/**
 * @member {Date} accepted_at
 */

_CreateQuote["default"].prototype['accepted_at'] = undefined;
/**
 * Not implemented
 * @member {Date} approved_by_rfq_at
 */

_CreateQuote["default"].prototype['approved_by_rfq_at'] = undefined;
/**
 * @member {Boolean} can_dispatch
 */

_CreateQuote["default"].prototype['can_dispatch'] = undefined;
/**
 * Id of the carrier for this quote. A carrier should always be provided when the requester's company would in fact be the carrier for the shipment. 
 * @member {String} carrier
 */

_CreateQuote["default"].prototype['carrier'] = undefined;
/**
 * @member {Array.<module:model/QuoteChargeLineItem>} charge_line_items
 */

_CreateQuote["default"].prototype['charge_line_items'] = undefined;
/**
 * @member {Date} created_at
 */

_CreateQuote["default"].prototype['created_at'] = undefined;
/**
 * @member {module:model/SlimCompany} created_by_company
 */

_CreateQuote["default"].prototype['created_by_company'] = undefined;
/**
 * @member {String} created_by_user
 */

_CreateQuote["default"].prototype['created_by_user'] = undefined;
/**
 * Read-only currency code describing the currency of line items on the quote
 * @member {module:model/CreateQuote.CurrencyEnum} currency
 * @default 'USD'
 */

_CreateQuote["default"].prototype['currency'] = 'USD';
/**
 * Markup charge to the end customer, obfuscated so only authorized users can read/write its true value 
 * @member {Number} customer_markup
 */

_CreateQuote["default"].prototype['customer_markup'] = undefined;
/**
 * Planned delivery date of the shipment, in string of the form YYYY-MM-DD
 * @member {String} delivery_date
 */

_CreateQuote["default"].prototype['delivery_date'] = undefined;
/**
 * Human-readable date/time of earliest pickup, if one exists
 * @member {String} display_earliest_pickup
 */

_CreateQuote["default"].prototype['display_earliest_pickup'] = undefined;
/**
 * Earliest date the shipment could be run, in string of the form YYYY-MM-DD
 * @member {String} earliest_pickup_date
 */

_CreateQuote["default"].prototype['earliest_pickup_date'] = undefined;
/**
 * Earliest time the shipment could be run
 * @member {String} earliest_pickup_time
 */

_CreateQuote["default"].prototype['earliest_pickup_time'] = undefined;
/**
 * Id of the EquipmentType for this quote
 * @member {Number} equipment_type
 */

_CreateQuote["default"].prototype['equipment_type'] = undefined;
/**
 * Error that happened during quoting
 * @member {String} error_message
 */

_CreateQuote["default"].prototype['error_message'] = undefined;
/**
 * @member {Date} expires_at
 */

_CreateQuote["default"].prototype['expires_at'] = undefined;
/**
 * @member {module:model/FedexDirectQuote} fedex_direct_quote
 */

_CreateQuote["default"].prototype['fedex_direct_quote'] = undefined;
/**
 * @member {String} id
 */

_CreateQuote["default"].prototype['id'] = undefined;
/**
 * Description of caveats about the quote
 * @member {String} info_message
 */

_CreateQuote["default"].prototype['info_message'] = undefined;
/**
 * True iff Quote originated from a rate that a Brokerage negotiated on behalf of one of their FreightAuthorities 
 * @member {Boolean} is_csp_rate
 */

_CreateQuote["default"].prototype['is_csp_rate'] = undefined;
/**
 * if true, this Quote does not represent an actual price but instead a failure to provide a Quote to an RFQ 
 * @member {Boolean} is_failure
 */

_CreateQuote["default"].prototype['is_failure'] = undefined;
/**
 * @member {module:model/CreateQuote.LaneTypeEnum} lane_type
 * @default 'UNSPECIFIED'
 */

_CreateQuote["default"].prototype['lane_type'] = 'UNSPECIFIED';
/**
 * Id of the ShipmentMode for this quote
 * @member {Number} mode
 */

_CreateQuote["default"].prototype['mode'] = undefined;
/**
 * URL for the logo of the quote provider
 * @member {String} provider_logo_url
 */

_CreateQuote["default"].prototype['provider_logo_url'] = undefined;
/**
 * @member {Array.<module:model/Accessorial>} quoted_non_dispatchable_accessorials
 */

_CreateQuote["default"].prototype['quoted_non_dispatchable_accessorials'] = undefined;
/**
 * @member {String} reference_number
 */

_CreateQuote["default"].prototype['reference_number'] = undefined;
/**
 * Not implemented
 * @member {Date} revoked_at
 */

_CreateQuote["default"].prototype['revoked_at'] = undefined;
/**
 * Id of the RFQ to which this quote is related
 * @member {String} rfq
 */

_CreateQuote["default"].prototype['rfq'] = undefined;
/**
 * Id of the ServiceLevel for this quote
 * @member {Number} service_level
 */

_CreateQuote["default"].prototype['service_level'] = undefined;
/**
 * @member {module:model/CreateQuote.SourceTypeEnum} source_type
 */

_CreateQuote["default"].prototype['source_type'] = undefined;
/**
 * @member {module:model/SpotNegotiationQuoteInfo} spot_negotiation_quote
 */

_CreateQuote["default"].prototype['spot_negotiation_quote'] = undefined;
/**
 * Sum of all the charge line items of this quote
 * @member {Number} total
 */

_CreateQuote["default"].prototype['total'] = undefined;
/**
 * @member {Number} transit_days
 */

_CreateQuote["default"].prototype['transit_days'] = undefined;
/**
 * @member {Date} updated_at
 */

_CreateQuote["default"].prototype['updated_at'] = undefined;
/**
 * @member {module:model/UPSDirectQuote} ups_direct_quote
 */

_CreateQuote["default"].prototype['ups_direct_quote'] = undefined;
/**
 * @member {module:model/USPSDirectQuote} usps_direct_quote
 */

_CreateQuote["default"].prototype['usps_direct_quote'] = undefined; // Implement CreateSpotNegotiationQuoteAllOf interface:

/**
 * Message to include in quote created email
 * @member {String} message
 */

_CreateSpotNegotiationQuoteAllOf["default"].prototype['message'] = undefined;
/**
 * Allowed values for the <code>currency</code> property.
 * @enum {String}
 * @readonly
 */

CreateSpotNegotiationQuote['CurrencyEnum'] = {
  /**
   * value: "CAD"
   * @const
   */
  "CAD": "CAD",

  /**
   * value: "USD"
   * @const
   */
  "USD": "USD"
};
/**
 * Allowed values for the <code>lane_type</code> property.
 * @enum {String}
 * @readonly
 */

CreateSpotNegotiationQuote['LaneTypeEnum'] = {
  /**
   * value: "DIRECT"
   * @const
   */
  "DIRECT": "DIRECT",

  /**
   * value: "INTERLINE"
   * @const
   */
  "INTERLINE": "INTERLINE",

  /**
   * value: "UNSPECIFIED"
   * @const
   */
  "UNSPECIFIED": "UNSPECIFIED"
};
/**
 * Allowed values for the <code>source_type</code> property.
 * @enum {String}
 * @readonly
 */

CreateSpotNegotiationQuote['SourceTypeEnum'] = {
  /**
   * value: "INSTANT"
   * @const
   */
  "INSTANT": "INSTANT",

  /**
   * value: "MANUAL"
   * @const
   */
  "MANUAL": "MANUAL",

  /**
   * value: "PRIVATE_MARKETPLACE"
   * @const
   */
  "PRIVATE_MARKETPLACE": "PRIVATE_MARKETPLACE"
};
var _default = CreateSpotNegotiationQuote;
exports["default"] = _default;